var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.3 13.05"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 6.85a.38.38 0 0 1 0-.6l5.4-5.4a.495.495 0 0 0-.7-.7l-5.4 5.4a.37.37 0 0 1-.6 0L.85.15a.495.495 0 1 0-.7.7l5.4 5.4a.38.38 0 0 1 0 .6l-5.4 5.4a.48.48 0 0 0 0 .7c.1.1.2.1.4.1s.3 0 .4-.1l5.4-5.4a.38.38 0 0 1 .6 0l5.4 5.4c.1.1.2.1.4.1s.3 0 .4-.1a.48.48 0 0 0 0-.7Z"
  })));
};
export default SvgClose;